/* ==========================================================================
   ModalLoading > Client > Prototype
   ========================================================================== */

/* Prototype */
const prototype = {
    /**
     * Set content to loading
     * @param {object} data Object containing the data to set { image, title, description, message }
     * @returns {object} Current instance
     */
    set: function setContent({ title = false, description = false, message = false, image = false } = {}) {
        this.loading.set({
            title,
            description,
            message,
            image
        });

        return this;
    },
    /**
     * Display modal
     * @returns {object} Current instance
     */
    display: function display() {
        this.modal.display();

        return this;
    },
    /**
     * Remove event listener
     * @returns {object} Current instance
     */
    removeEventListener: function removeEventListener() {
        /* Modal */
        this.modal.removeEventListener();

        return this;
    },
    /**
     * Add event listener
     * @returns {object} Current instance
     */
    addEventListener: function addEventListener() {
        /* Modal */
        this.modal.addEventListener();

        return this;
    },
    /**
     * Start
     * @returns {object} Current instanace
     */
    start: function start() {
        this
            /* Display modal */
            .display()
            /* Remove events */
            .removeEventListener()
            /* Init loading */
            .loading.init();
    }
};

/* Exports */
module.exports = prototype;
